import React from "react";

function Clock_Start() {
  return (
    <div>
      <h1>Clock_Start Component</h1>
      <p>This is the Clock Start tutorial page content.</p>
    </div>
  );
}

export default Clock_Start;
